import React from "react";

export default function StatsSection() {
  return (
    <section class="py-4 bg-white">
      <div class="container py-5">
        <div class="row g-4">
          <div class="section-title citizenship-title">
            <h2 class="mb-3">USCIS 2025 - Q1 Data</h2>
            <p>
              <a
                target="_blank"
                className="source"
                href="https://www.uscis.gov/sites/default/files/document/data/quarterly_all_forms_fy2025_q1.xlsx"
              >
                Source
              </a>
            </p>
          </div>
          <div class="col-md-4">
            <div class="stat-card greencard-stat animate-on-scroll">
              <div class="stat-number">204,180</div>
              <h5>Green Card Renewal<br/> Approved</h5>
              {/* <p>Status Secured</p> */}
            </div>
          </div>
          <div class="col-md-4">
            <div class="stat-card family-stat animate-on-scroll">
              <div class="stat-number">145,524</div>
              <h5>Families Reunited</h5>
              <p>Through services</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="stat-card citizenship-stat animate-on-scroll">
              <div class="stat-number">205,488</div>
              <h5>Citizenship Naturalization <br/>Approved</h5>
              {/* <p>First-time application success</p> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
